export const cartNovelty = () => {
    document.addEventListener( 'DOMContentLoaded', () => {
        const holdNoveltyCampaign = document.querySelector('#novely_minumum_price');
        if ( holdNoveltyCampaign ) {

            const nowtime_element = document.querySelector('#novely_now_time').value;
            const nowtime = formatDateTime(nowtime_element);
            const novely_start_time_element = document.querySelector('#novely_start_time').value;
            const novely_start_time = formatDateTime(novely_start_time_element);
            const novely_end_time_element = document.querySelector('#novely_end_time').value;
            const novely_end_time = formatDateTime(novely_end_time_element);

            if ( nowtime.getTime() >= novely_start_time.getTime() && nowtime <= novely_end_time.getTime() ) {
                const novelty_minimum_price = holdNoveltyCampaign.value;
                const current_cart_ammount_price = document.querySelector('[data-total-price]').dataset.totalPrice;
                const novelty_message_container = document.querySelector('#novelty_message_container');
                const price_defference = novelty_minimum_price - current_cart_ammount_price
                const novelty_message = document.querySelector('#novelty_message').innerHTML;
                if ( price_defference > 0) {
                    novelty_message_container.innerHTML = `あと${price_defference.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })} ${novelty_message}`;
                }
            }
            
        }
    })
}

const formatDateTime = (dateString) => {
    const parts = dateString.split(/[\s/:]+/); // 文字列を分割して日付要素を取得

    // Dateオブジェクトに要素を設定
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1; // JavaScriptの月は0から始まるため、1を引きます
    const day = parseInt(parts[2]);
    const hour = parseInt(parts[3]);
    const minute = parseInt(parts[4]);
    const second = parseInt(parts[5]);

    const date = new Date(year, month, day, hour, minute, second);
    return date;
}